import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Modal, Button, Form } from "react-bootstrap";
import { get } from "lodash";
import {
  getColor,
  isValidArray,
  transformProjectCategoryId
} from "../../../helper";
import UploadProjectIssueSingle from "./UploadProjectIssueSingle";
import { PATHS, ISSUE_STATUS } from "../../../constant";
import { Link } from "react-router-dom";
import { EscalationLevelModal } from "../../reusableComponent/EscalationLevel/EscalationLevelModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toolttipDisplayMessage } from "../../issueList/helper";
import { DisplayContent } from "../../displayContent";
import DisplayByPermission from "../../../component/DisplayByPermission";

export class UploadIssueSingle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //selectedProjectIssues: [],
    };
  }

  render() {
    const {
      issue,
      meetingStatus,
      permission,
      onToggle,
      projectId,
      project
    } = this.props;
    const content = (
      <Form.Group controlId={`checkbox-${this.props.idx}`}>
        <Form.Check
          className={`form-checkbox ${issue.isSelected ? "checked" : ""} ${
            !project.isSelected ? "disabled" : ""
          }`}
        >
          <Form.Check.Input
            type="checkbox"
            name="select-issue"
            value={issue.isSelected}
            checked={issue.isSelected}
          />
          <Form.Check.Label onClick={() => onToggle(projectId, issue.id)} />
        </Form.Check>
      </Form.Group>
    );
    return (
      <React.Fragment>
        <div className="select-issue-wrapper agenda-issue-wrapper">
          <Form className="select-issue-form">{content}</Form>
          <div className="issue-container">
            <div className="select-issue-content">
              <div className="issue-list-top">
                <div className="issue-list-header">
                  <div className="issue-status">
                    <span
                      className={`issue-number mt-1 ${
                        get(issue, "duplicate") ? "duplicate-issue-number" : ""
                      }`}
                    >
                      {get(issue, "duplicate") ? "Duplicate Issue" : "Issue"}{" "}
                      <b>
                        <Link
                          to={{
                            pathname: PATHS.ISSUE_DETAIL,
                            search: `?issueId=${get(
                              issue,
                              "id"
                            )}&&projectId=${get(issue, "project.id")}`
                          }}
                        >
                          #{get(issue, "project.displayId", "NA")}/
                          {get(issue, "id", "NA")}
                        </Link>
                      </b>
                    </span>
                    {/**CR 289 Changes Starts-Yajnadutta */}
                    <div className="mt-1" style={{ marginLeft: -10 }}>
                      {get(issue, "escalationLevelName", "NA") ==
                      null ? null : (
                        <EscalationLevelModal
                          IssueId={get(issue, "id")}
                          EscalationName={get(
                            issue,
                            "escalationLevelName",
                            "NA"
                          )}
                          pragatiDetailPage={true}
                          pragatiDetailPageCss={true}
                        />
                      )}
                    </div>
                    {/**CR 289 Changes End-Yajnadutta */}
                    <OverlayTrigger
                      defaultShow={false}
                      trigger="hover"
                      placement="top"
                      overlay={
                        <Tooltip className="issues-status-tooltip ">
                          {toolttipDisplayMessage(get(issue, "status", "NA"))}
                        </Tooltip>
                      }
                    >
                      <div className="issue-list-status mt-1">
                        <span
                          className={`issue-status-btn  ${getColor(
                            get(issue, "status", "NA").toLowerCase()
                          )} unClickable`}
                        >
                          {get(issue, "status", "NA")}
                        </span>
                      </div>
                    </OverlayTrigger>
                  </div>

                  {/* <h2 className="issue-title">{get(issue, "title", "NA")}</h2> */}
                  <h2
                    className="issue-title"
                    style={{
                      lineHeight: get(issue, "title", "NA").match(
                        /[\u0900-\u097F]/
                      )
                        ? "inherit"
                        : ""
                    }}
                  >
                    <Link
                      to={{
                        pathname: PATHS.ISSUE_DETAIL,
                        search: `?issueId=${get(issue, "id")}&&projectId=${get(
                          issue,
                          "project.id"
                        )}`
                      }}
                    >
                      <span
                        className={`${
                          get(issue, "title", "NA").match(/[\u0900-\u097F]/)
                            ? "hindi-text-wrap"
                            : ""
                        }`}
                      >
                        {get(issue, "title", "NA")}
                      </span>
                    </Link>
                  </h2>
                </div>
              </div>
              <div
                className={
                  meetingStatus === "DRAFT"
                    ? "issue-list-flag-wrapper"
                    : "issue-agenda-detail-flag-wrapper"
                }
              >
                <div className="issue-list-desc-comment-wrapper">
                  <div className="issue-list-middle issue-list-align">
                    <div className="issue-list-desc-wrapper">
                      <span className="issue-recipient">
                        <span className="issue-recipient-title">
                          Recipient{" "}
                          {transformProjectCategoryId(
                            get(issue, "recipientGroupCategory")
                          )}
                          : &nbsp;
                        </span>
                        {get(issue, "recipientGroup", "NA")}
                      </span>
                      {console.log("get(issue, recipientLabel)", issue)}
                      {get(issue, "districtName") ? (
                        <span className="issue-recipient">
                          <span className="issue-recipient-title">
                            {get(issue, "recipientLabel")}:
                          </span>{" "}
                          &nbsp;
                          {get(issue, "districtName", "NA")}
                        </span>
                      ) : null}
                      {get(issue, "secondaryState") ||
                      get(issue, "secondaryRecipientGroupName") ? (
                        <span className="issue-recipient">
                          <span className="issue-recipient-title">
                            Secondary Recipient:
                          </span>{" "}
                          {get(issue, "secondaryState", "NA") ||
                            get(issue, "secondaryRecipientGroupName", "NA")}
                        </span>
                      ) : get(issue, "secondaryMinistry") ? (
                        <span className="issue-recipient">
                          <span className="issue-recipient-title">
                            Secondary Recipient:
                          </span>{" "}
                          {get(issue, "secondaryMinistry", "NA")}
                        </span>
                      ) : null}
                      <p className="issue-category to-n-fro">
                        <span className="">
                          <span className="issue-category-title">
                            Issue Category: &nbsp;
                          </span>
                          {get(issue, "category", "NA")}
                        </span>
                        <span className="clowdy" />
                      </p>
                      {get(issue, "subCategory") ? (
                        <p className="issue-sub-category to-n-fro">
                          <span className="">
                            <span className="issue-category-title">
                              Issue Sub-Category: &nbsp;
                            </span>
                            {get(issue, "subCategory", "NA")}
                          </span>
                          <span className="clowdy" />
                        </p>
                      ) : null}
                      {get(issue, "proposalNoParivesh") ? (
                        <p className="issue-sub-category to-n-fro">
                          <span className="slide-issue">
                            <span className="issue-category-title">
                              Proposal No. (Parivesh): &nbsp;
                            </span>
                            {get(issue, "proposalNoParivesh", "NA")}
                          </span>
                          <span className="clowdy" />
                        </p>
                      ) : null}
                    </div>
                  </div>
                  {(meetingStatus === "DRAFT" &&
                    get(issue, "latestIssueComments") && (
                      <div className="issue-list-comment">
                        <div className="comment-heading">
                          <h3>Latest Comment</h3>
                        </div>
                        <DisplayContent
                          classes={"issue-list-desc"}
                          content={get(issue, "latestIssueComments")}
                        />
                      </div>
                    )) ||
                    null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    uploadProjectIssuesReducer: state.donwloadExcelReducer.uploadProjectIssues,
    uploadedList: state.donwloadExcelReducer.uploadProjectIssues.uploadedList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      //uploadProjectIssuesAction,
      //clearUploadProjectIssuesAction,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadIssueSingle);
